import apiClient from '../apiClient';

export const createExtractionField = (fieldData) => {
  return apiClient.post('/extraction-fields', fieldData);
};

export const updateExtractionField = (id, fieldData) => {
  return apiClient.put(`/extraction-fields/${id}`, fieldData);
};

export const deleteExtractionField = (id) => {
  return apiClient.delete(`/extraction-fields/${id}`);
};

export const uploadMultipleInvoices = (formData, onProgress) => {
  return apiClient.post('/invoiceupload/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: onProgress
  });
};

export const getExtractionRules = () => {
  return apiClient.get('/invoiceupload/extraction-rules');
};

export const getExtractionFields = () => {
  return apiClient.get('/extraction-fields');
};

export const getExtractionJobs = (status, showArchived = false) => {
  return apiClient.get('/extraction-jobs', { params: { status, showArchived } });
};

export const getCustomerExtractionJobs = (status, showArchived = false, customerId = null, metadataFilters = null, page = 1, pageSize = 25, sortModel = [], filterModel = { items: [] }, rulesetId = null) => {
  const params = { 
    status, 
    showArchived, 
    page, 
    pageSize,
    customerId: customerId || undefined,
    rulesetId: rulesetId || undefined,
    metadataFilters: metadataFilters ? JSON.stringify(metadataFilters) : undefined
  };
  
  if (sortModel.length > 0) {
    params.sortBy = sortModel[0].field;
    params.sortDesc = sortModel[0].sort === 'desc';
  }
  
  if (filterModel.items.length > 0) {
    params.filters = JSON.stringify(filterModel.items);
  }
  
  return apiClient.get('/customer/extraction-jobs', { params });
};

export const archiveExtractionJob = (jobId) => {
  return apiClient.post(`/extraction-jobs/${jobId}/archive`);
};

export const unarchiveExtractionJob = (jobId) => {
  return apiClient.post(`/extraction-jobs/${jobId}/unarchive`);
};

export const downloadExtractionJobArchive = (jobId) => {
  return apiClient.get(`/extraction-jobs/${jobId}/archive`, {
    responseType: 'blob',
    timeout: 60000
  });
};

export const getExtractionResults = (jobId) => {
  return apiClient.get(`/extraction-jobs/${jobId}`);
};

export const compareExtractionResults = (jobId) => {
  return apiClient.get(`/extraction-jobs/${jobId}/comparison`);
};

export const resolveDiscrepancies = (jobId, data) => {
  const body = {
    resolutions: data.resolutions,
    reviewComments: data.reviewComments,
    questionCode: data.questionCode,
    errorCode: data.errorCode,
  };
  
  // Include LineItems array for identity-based reconciliation
  if (data.LineItems) {
    body.LineItems = data.LineItems;
  }
  
  return apiClient.post(`/extraction-jobs/${jobId}/resolve`, body);
};

export const retryExtractionJob = (jobId) => {
  return apiClient.post(`/extraction-jobs/${jobId}/retry`);
};

export const markAsUnprocessable = (jobId, reason) => {
  return apiClient.post(`/extraction-jobs/${jobId}/mark-unprocessable`, { reason });
};

export const getExtractionJobFile = (jobId) => {
  return apiClient.get(`/extraction-jobs/${jobId}/file`, {
    responseType: 'blob'
  });
};

export const getExtractionJobPrompts = (jobId) => {
  return apiClient.get(`/extraction-jobs/${jobId}/prompts`);
};

export const getExtractionJobPrompt = (jobId, promptId) => {
  return apiClient.get(`/extraction-jobs/${jobId}/prompts/${promptId}`);
};

export const runCustomPrompt = (jobId, data) => {
  return apiClient.post(`/extraction-jobs/${jobId}/run-prompt`, data);
};

export const GetCustomersWiseStatus = () => {
  return apiClient.get('/customers/status-summary');
};

export const getCustomerRulesetStatusBreakdown = (customerId) => {
  return apiClient.get(`/customers/${customerId}/ruleset-status-breakdown`);
};

export const exportExtractionJob = (jobId, data = {}) => {
  return apiClient.post(`/extraction-jobs/${jobId}/export`, {
    questionCode: data.questionCode,
    errorCode: data.errorCode
  });
};

export const getExtractionJobStatistics = () => {
  return apiClient.get('/extraction-jobs/statistics');
};

export const retryExportExtractionJob = (jobId) => {
  return apiClient.post(`/extraction-jobs/${jobId}/retry-export`);
};

export const forceReprocessExtractionJob = (jobId) => {
  return apiClient.post(`/extraction-jobs/${jobId}/force-reprocess`);
};

export const bulkCopyFields = (sourceRulesetId, targetRulesetId, fieldIds = null) => {
  return apiClient.post('/extraction-fields/bulk-copy', {
    sourceRulesetTypeId: parseInt(sourceRulesetId),
    targetRulesetTypeId: parseInt(targetRulesetId),
    fieldIds: fieldIds
  });
};

export const getModelCostRates = () => {
  return apiClient.get('/model-cost-rates');
};

export const upgradeLineItems = (jobId) => {
  return apiClient.post(`/extraction-jobs/${jobId}/upgrade-line-items`);
};
